import { t } from '../cards/i18n'
import { paths } from '../cards/icons'

const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, char => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
}[char]))

const icon = (name, id, hidden = false) => `<svg ${id ? `id="${id}"` : ''} class="${hidden ? 'd-none' : ''}" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${paths[name]}"></path></svg>`

function rows(data, offset, topic = false) {
  return `<div class="cards-catalog-words">${data.map((item, index) => {
    const added = item.user_has_flashcard
    return `<div class="cards-catalog-word"><div class="cards-grow"><strong>${escapeHtml(item.word)}</strong><p class="cards-muted cards-small">${escapeHtml(topic ? item.english_translation : item.translation)}</p></div>
      <button type="button" class="cards-add-btn cards-catalog-add ${added ? 'cards-added' : ''} ${topic ? '' : 'js-add-word-btn'}" ${added ? 'disabled' : ''} aria-label="${escapeHtml(t(added ? 'added' : 'add_to_vocabulary'))}" data-word="${escapeHtml(item.word)}" data-translation="${escapeHtml(item.translation)}" data-index="${index}" data-offset="${offset}">
      ${icon('plus', `plus-icon-${index}`, added)}${icon('check', `check-icon-${index}`, !added)}</button></div>`
  }).join('')}</div>`
}

function commonBody(data, offset) {
  const allAdded = data.length > 0 && data.every(item => item.user_has_flashcard)
  return `<div class="cards-row cards-wrap cards-pack-actions">
    <button type="button" class="cards-btn cards-save cards-catalog-add-all ${allAdded ? 'd-none' : ''}" id="js-add-all-words-btn" data-offset="${offset}">${icon('plus')}${escapeHtml(t('packs_add_all'))}</button>
    <button type="button" class="cards-btn cards-added cards-catalog-add-all ${allAdded ? '' : 'd-none'}" id="check-icon-all-words" disabled>${icon('check')}${escapeHtml(t('added'))}</button>
    <button type="button" class="cards-btn cards-ghost cards-danger-text ${allAdded ? '' : 'd-none'}" id="js-remove-all-words-btn" data-offset="${offset}">${escapeHtml(t('packs_remove_all'))}</button>
  </div>${rows(data, offset)}
  <a href="/langua/vocabulary">${escapeHtml(t('packs_go_cards'))}</a>`
}

function topicBody(data, labels) {
  if (!data.length) return `<p>${escapeHtml(labels.empty)}</p>`
  const allAdded = data.every(item => item.user_has_flashcard)
  return `${rows(data, 0, true)}<div class="cards-row cards-wrap cards-topic-actions">
    <button type="button" class="cards-btn cards-save cards-catalog-add-all ${allAdded ? 'd-none' : ''}" id="add-all-words">${icon('plus')}${escapeHtml(labels.add)}</button>
    <button type="button" class="cards-btn cards-added cards-catalog-add-all ${allAdded ? '' : 'd-none'}" id="check-icon-all-words" disabled>${icon('check')}${escapeHtml(labels.added)}</button>
    <button type="button" class="cards-btn cards-primary" id="read-story">${icon('book')}${escapeHtml(labels.read)}</button>
  </div><p class="cards-muted cards-small">${escapeHtml(labels.context)}</p>`
}

window.webCardsCatalog = { topicBody }
export { commonBody }
